export default __webpack_public_path__ + "static/media/RaviTejaDP.8700d425.png";